import React from "react";
import { LivechatSubjectType } from "@scrile/api-provider/dist/api/LivechatsProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import useProduceConsumeController from "./useProduceConsumeController";
import ConferenceView from "../ConferenceView";

interface Props {
  livechatSubject: Subject<LivechatSubjectType>;
  conferenceUuid: string;
  ownerId: string;
  groupId?: string;
  onClose: () => void;
  groupThreadId?: string;
}

export default function ConferenceStreamController({ livechatSubject, conferenceUuid, ownerId, groupId, onClose, groupThreadId }: Props) {
  const {
    threadId,
    userList,
    produceMediaConstraints,
    loading,
    token,
    audioInputs,
    videoInputs,
    users,
    me,
    streamStartedDate,
    isConferenceOwner,
    connectionStatus,
    rejoinInSeconds,
    rejoinNow,
    webRTC,
    networkQuality,
    remoteQualities,
    onChangeConstraints,
    onCloseStream,
    toggleMuteUser,
    setBackgroundImage,
    setBackgroundMode,
  } = useProduceConsumeController(livechatSubject, ownerId);

  return (
    <ConferenceView
      threadId={threadId}
      conferenceUuid={conferenceUuid}
      loading={loading}
      userList={userList}
      token={token}
      showConfirmationExit
      users={users}
      me={me}
      isConferenceOwner={isConferenceOwner}
      managedConstraints={produceMediaConstraints}
      audioInputs={audioInputs}
      videoInputs={videoInputs}
      streamStartedDate={streamStartedDate}
      muteUser={toggleMuteUser}
      onChangeConstraints={onChangeConstraints}
      onCloseConference={onClose}
      onCloseStream={onCloseStream}
      groupThreadId={groupThreadId}
      groupId={groupId}
      connectionStatus={connectionStatus}
      rejoinInSeconds={rejoinInSeconds}
      rejoinNow={rejoinNow}
      webRTC={webRTC}
      networkQuality={networkQuality}
      remoteQualities={remoteQualities}
      onSetBackgroundImage={setBackgroundImage}
      onSetBackgroundMode={setBackgroundMode}
    />
  );
}
